import pythonApiClient from './pythonBaseApi';

/**
 * Servicio para gestión de asignaciones Comedor-Comensal
 * Maneja todas las operaciones relacionadas con la tabla pivot comedor_comensal
 * 
 * NOTA: Los endpoints de asignaciones ahora usan Python (FastAPI)
 */
export const comedorComensalApi = {
  /**
   * Obtener todas las asignaciones comedor-comensal
   * @param {number|null} idComedor - ID del comedor (opcional)
   * @param {number|null} idComensal - ID del comensal (opcional)
   * @returns {Promise} - Respuesta de la API
   */
  getAll: async (idComedor = null, idComensal = null) => {
    const params = new URLSearchParams();
    if (idComedor) params.append('id_comedor', idComedor);
    if (idComensal) params.append('id_comensal', idComensal);
    
    const endpoint = params.toString() 
      ? `/comedor-comensal?${params.toString()}`
      : '/comedor-comensal';
    
    // Usar endpoint de Python (FastAPI)
    const response = await pythonApiClient.get(endpoint);
    return response.data;
  },

  /**
   * Obtener comedores asignados a un comensal específico
   * @param {number} comensalId - ID del comensal
   * @returns {Promise} - Respuesta de la API
   */
  getComedoresByComensal: async (comensalId) => {
    // Usar endpoint de Python (FastAPI)
    const response = await pythonApiClient.get(`/comensales/${comensalId}/comedores`);
    return response.data || [];
  },

  /**
   * Obtener comensales asignados a un comedor específico
   * @param {number} comedorId - ID del comedor
   * @returns {Promise} - Respuesta de la API
   */
  getComensalesByComedor: async (comedorId) => {
    // Usar endpoint de Python (FastAPI)
    const response = await pythonApiClient.get(`/comedores/${comedorId}/comensales`);
    return response.data || [];
  },

  /**
   * Asignar un comedor específico a un comensal
   * @param {number} comensalId - ID del comensal
   * @param {number} comedorId - ID del comedor
   * @returns {Promise} - Respuesta de la API
   */
  asignarComedor: async (comensalId, comedorId) => {
    // Usar endpoint de Python (FastAPI)
    // El backend espera id_comedor e id_comensal
    const response = await pythonApiClient.post('/comedor-comensal/asignar', {
      id_comensal: comensalId,
      id_comedor: comedorId
    });
    return response.data;
  },

  /**
   * Desasignar un comedor específico de un comensal
   * @param {number} comensalId - ID del comensal
   * @param {number} comedorId - ID del comedor
   * @returns {Promise} - Respuesta de la API
   */
  desasignarComedor: async (comensalId, comedorId) => {
    // Usar endpoint de Python (FastAPI)
    // El backend espera id_comedor e id_comensal
    const response = await pythonApiClient.post('/comedor-comensal/desasignar', {
      id_comensal: comensalId,
      id_comedor: comedorId
    });
    return response.data;
  },

  /**
   * Actualizar todas las asignaciones de comedores para un comensal
   * NOTA: Este endpoint puede no estar disponible en Python.
   * Si no funciona, usar asignar/desasignar individualmente o actualizar el comensal con comedores.
   * @param {number} comensalId - ID del comensal
   * @param {number[]} comedoresIds - Array de IDs de comedores
   * @returns {Promise} - Respuesta de la API
   */
  updateComedoresAsignados: async (comensalId, comedoresIds) => {
    // Intentar usar endpoint de Python (FastAPI)
    // Si no existe, se puede implementar usando asignar/desasignar
    try {
      const response = await pythonApiClient.put(`/comensales/${comensalId}/comedores`, {
        comedores: comedoresIds || []
      });
      return response.data;
    } catch (error) {
      // Si el endpoint no existe, implementar lógica alternativa
      console.warn('Endpoint PUT /comensales/{id}/comedores no disponible en Python, usando método alternativo');
      // TODO: Implementar lógica de asignar/desasignar individualmente
      // Por ahora, lanzar el error para que el componente maneje el fallback
      throw error;
    }
  }
};
